import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AppModalInterface } from '../../lib-interfaces/app-modal.interface';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements AppModalInterface {

  @Input() title: string;
  @Input() message: string;
  @Input() button_title: string = 'Confirm';
  @Input() button_colour_class: string = '-color-success';
  @Input() message_is_html: boolean = false;

  @Output() close = new EventEmitter<boolean>();
  @Output() dismiss = new EventEmitter<void>();

  confirm() {
    this.close.emit(true);
  }

  cancel() {
    this.dismiss.emit();
  }

}
